import { ApolloClient, InMemoryCache, createHttpLink, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { TECHNOLOGY_QUERY } from "graphql/technology";

// Bearer token is stored by auth flow in localStorage
const getBearerToken = () => {
  try {
    return localStorage.getItem("accessToken") || "";
  } catch {
    return "";
  }
};

// Apollo Client instance for technology service
let technologyClient = null;

/**
 * Initialize Apollo Client for technology service
 * @returns {ApolloClient} Configured Apollo Client instance
 */
const getTechnologyClient = () => {
  if (technologyClient) {
    return technologyClient;
  }

  const httpLink = createHttpLink({
    uri: process.env.REACT_APP_DOORSHARP_GRAPHQL_ENDPOINT,
  });

  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      "Content-Type": "application/json",
      ...(getBearerToken() ? { Authorization: `Bearer ${getBearerToken()}` } : {}),
    },
  }));

  technologyClient = new ApolloClient({
    link: from([authLink, httpLink]),
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        fetchPolicy: "network-only",
        errorPolicy: "all",
      },
    },
  });

  return technologyClient;
};

export async function fetchTechnology() {
  try {
    const client = getTechnologyClient();

    const { data } = await client.query({
      query: TECHNOLOGY_QUERY,
      fetchPolicy: "network-only",
    });

    console.log("Technology GraphQL response:", data);
    return data;
  } catch (error) {
    console.error("Technology GraphQL error:", error);
    throw error;
  }
}

